import createCache from '@emotion/cache';
import { useMantineEmotionCache } from '../theme/MantineProvider.js';
var defaultMantineEmotionCache = createCache({
  key: "mantine",
  prepend: true
});

function useEmotionCache() {
  var cache = useMantineEmotionCache();
  return cache || defaultMantineEmotionCache;
}

export { defaultMantineEmotionCache, useEmotionCache };